import logo from "../assets/logo.jpg";
import { CONTACT_EMAIL } from "../config";

const socials = [
  {
    name: "Instagram",
    testid: "social-instagram",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
        <circle cx="12" cy="12" r="4.2" />
        <circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    name: "X",
    testid: "social-x",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <path d="M4 4l16 16M20 4L4 20" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    testid: "social-linkedin",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="2.5" y="2.5" width="19" height="19" rx="4" />
        <path d="M7.5 10.5V17" strokeLinecap="round" />
        <circle cx="7.5" cy="7.6" r="1.1" fill="currentColor" stroke="none" />
        <path d="M11.5 17v-3.8c0-1.5 1.1-2.7 2.6-2.7s2.6 1.2 2.6 2.7V17" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    testid: "social-youtube",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="2" y="5.5" width="20" height="13" rx="4" />
        <path d="M10 9.3v5.4l4.8-2.7L10 9.3z" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img src={logo} alt="Logo LleGO" className="brand-logo" />
          <div>
            <span className="brand-name">LleGO</span>
            <p className="footer-tag">Tu ruta eléctrica, sin incertidumbre.</p>
          </div>
        </div>
        <div className="footer-col">
          <span className="footer-label">Contacto</span>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact-email">
            {CONTACT_EMAIL}
          </a>
        </div>
        <div className="footer-col">
          <span className="footer-label">Legal</span>
          <a href="#" data-testid="footer-link-terminos">Términos</a>
          <a href="#" data-testid="footer-link-privacidad">Privacidad</a>
        </div>
        <div className="footer-col">
          <span className="footer-label">Seguinos</span>
          <div className="footer-socials">
            {socials.map((s) => (
              <a key={s.name} href="#" aria-label={s.name} data-testid={s.testid}>
                {s.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>© 2026 LleGO · llegoev.com</span>
      </div>
    </footer>
  );
}
